import React, { useEffect, useRef, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import AdminSidebar from "../components/Admin/AdminSidebar";
import AdminHeader from "../components/Admin/AdminHeader";
import { IdleTimerProvider, useIdleTimerContext } from "react-idle-timer";
import { url } from "../configlink";
import { useSelector } from "react-redux";

const AdminLayout = () => {

  let navigate = useNavigate()

	let adminUser = useSelector((state) => state.userAdmin.userAdmin)
  
  let [expiryWarning, setExpiryWarning] = useState(false)
  
  const handleOnIdle = () => {
    console.log('Admin is idle');
    setExpiryWarning(false)
    // alert('Session ended due to inactivity!')
    
    try {
      fetch(`${url}/api/auth/admin_logout`, {
        method: "POST",
		credentials: "include", // Send cookies along with the request
		headers: {
			'acgt-admin': adminUser
		},
      })
      .then(res => res.json())
      .then(data => {
        if(data.message==='Logout successful'){
          localStorage.removeItem('token_expiry')
		localStorage.setItem('logoutmessage', 1)
          navigate("/adminlogin");
        }
      })
    } catch (error) {
      console.error(error);
      
    }

  };


  const RemainingTime = () => {
    const idleTimer = useIdleTimerContext();
    const [remaining, setRemaining] = useState(0);
  
    // useEffect(() => {
    //   const interval = setInterval(() => {
    //     const timeLeft = idleTimer.getRemainingTime();
    //     setRemaining(Math.ceil(timeLeft / 1000));
    //   }, 1000);
  
    //   return () => clearInterval(interval);
    // }, [idleTimer]);

    useEffect(() => {
      const interval = setInterval(() => {
        const timeLeft = idleTimer.getRemainingTime();

        
        const minutes = Math.floor(timeLeft / 1000 / 60);
        const seconds = Math.floor((timeLeft / 1000) % 60);
        
        if(minutes < 5){
          setExpiryWarning(true)
        }
  
        const formatted = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        setRemaining(formatted);
      }, 1000);
  
      return () => clearInterval(interval);
    }, [idleTimer]);
  
    return (
		<p className={`text-sm text-gray-500 px-10`}>
			Inactivity Timer: {remaining}
		</p>
    );
  };

  const lastRefresh = useRef(0);
  


  // console.log('adminUser:', adminUser);

  const handleOnAction = () => {
    setExpiryWarning(false)
    const now = Date.now();

    // throttle refresh check to once every 1 minute
    if (now - lastRefresh.current < 60000) return;

    const expiry = localStorage.getItem('token_expiry'); // stored when login happens
    
    if(expiry) {
      const timeLeft = Number(expiry) - now;
  
      if (timeLeft < 5 * 60 * 1000) {
          fetch(`${url}/api/auth/refreshAdminCookie`, {
              method: "POST",
              credentials:'include',
              headers: {
				"Content-Type": "application/json",
				'acgt-admin': adminUser
              },
              body: JSON.stringify({user: adminUser}),
          })
          .then(res => res.json())
          .then(data => {
            if (data.message === 'success'){
              localStorage.setItem('token_expiry', (Date.now() + 15 * 60 * 1000).toString());
              console.log('🔁 Cookie extended');
              lastRefresh.current = now;
            }
          })
          .catch(err => {
            console.log("Refresh token error"); 
          })
      }
    }
  };
  
	return (
    <IdleTimerProvider
    timeout={1001 * 60 * 15}
    onIdle={handleOnIdle}
    onAction={handleOnAction}
    debounce={500}
    >
        {expiryWarning && 
        <>
			<div className="w-full h-[100vh] fixed top-0 left-0 bg-black opacity-80 z-2 flex justify-center items-center">    
			</div>
			<div className=" fixed top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 w-[400px] h-[200px] z-3 bg-gray-300 rounded-md flex items-center justify-center">
				<p className="text-2xl text-center">Session expiring soon!</p>
			</div>
        </>
        }
        <div className='flex flex-col h-screen'>
        <RemainingTime />
        <header>
            <AdminHeader />
        </header>
        <main className='flex p-2'>
			<section className='w-64 min-w-[200px]'>
				<AdminSidebar />
			</section>
			<section className='flex-grow'>
				<Outlet />
			</section>
        </main>
		</div>
	</IdleTimerProvider>
	);
};

export default AdminLayout;